module.exports = __webpack_public_path__ + "img/tabar_exchange1.fcf3f496.png";